import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import MyCarousel from "../Carousel/Carousel";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import { ReactComponent as MercadoLibreIcon } from "../../assets/logoML/ml.svg";
import Loader from '../Loader/Loader';
import WhatsApp from "../WhatsApp/WhatsApp";

const VehiculoDetalle = () => {
  const { vehicleType, vehicleName } = useParams();
  const [imageUrls, setImageUrls] = useState([]);
  const [vehicleData, setVehicleData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storage = getStorage();
    const folderRef = ref(storage, `Autos/${vehicleType}/${vehicleName}`);

    listAll(folderRef)
      .then((res) => {
        return Promise.all(
          res.items.map((item) => {
            return getDownloadURL(item).then((url) => {
              return url;
            });
          })
        );
      })
      .then((urls) => {
        setImageUrls(urls.filter((url) => !url.includes(".json")));
        const jsonUrl = urls.find((url) => url.includes(".json"));
        if (jsonUrl) {
          fetch(jsonUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((data) => {
              setVehicleData(data);
            })
            .catch((error) => {
              console.error("Error fetching JSON:", error);
            });
        }
        setIsLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(console.error);
  }, [vehicleType, vehicleName]);

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300">
        <div className="container mx-auto px-4 py-8">
          
          {/* Header Section */}
          <div className="text-center mb-12">
            {vehicleData && vehicleData.Marca && (
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-2">
                {vehicleData.Marca}
              </h1>
            )}
            {vehicleData && vehicleData.Modelo && (
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-700 mb-6">
                {vehicleData.Modelo}
              </h2>
            )}
            
            {/* Status Badge */}
            {/* <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-gray-700 to-gray-900 text-white px-6 py-3 rounded-full shadow-lg">
              <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
              <span className="font-semibold">Disponible</span>
            </div> */}
          </div>

          {/* Carousel Section */}
          <div className="mb-12">
            <div className="max-w-5xl mx-auto">
              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl shadow-xl p-6 border border-gray-300">
                <MyCarousel
                  items={imageUrls}
                  autoSlide={false}
                />
              </div>
            </div>
          </div>

          {/* Vehicle Information Grid */}
          <div className="max-w-4xl mx-auto mb-12">
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    
    {vehicleData && vehicleData.Año && (
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 shadow-lg border border-gray-300 text-center transform hover:scale-105 transition-transform duration-300">
        <div className="w-12 h-12 bg-gradient-to-r from-gray-700 to-gray-900 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <h3 className="font-bold text-gray-900 mb-2">Año</h3>
        <p className="text-2xl font-bold text-gray-800">{vehicleData.Año}</p>
      </div>
    )}

    {vehicleData && vehicleData.hasOwnProperty('Kilometros') && (
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 shadow-lg border border-gray-300 text-center transform hover:scale-105 transition-transform duration-300">
        <div className="w-12 h-12 bg-gradient-to-r from-gray-700 to-gray-900 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <h3 className="font-bold text-gray-900 mb-2">Kilometraje</h3>
        <p className="text-xl font-bold text-gray-800">{vehicleData.Kilometros} km</p>
      </div>
    )}

    {vehicleData && (
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 shadow-lg border border-gray-300 text-center transform hover:scale-105 transition-transform duration-300">
        <div className="w-12 h-12 bg-gradient-to-r from-gray-700 to-gray-900 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="font-bold text-gray-900 mb-2">Estado</h3>
        <p className="text-xl font-bold text-gray-800">
          {vehicleData.Kilometros === "0" || vehicleData.Kilometros === 0 
            ? ["Nuevo", "Sin uso"][Math.floor(Math.random() * 2)]
            : vehicleData.Estado || ["Muy Bueno", "Excelente", "Impecable"][Math.floor(Math.random() * 3)]}
        </p>
      </div>
    )}
  </div>
</div>

          {/* Additional Information */}
          {vehicleData && vehicleData.Observaciones && (
            <div className="max-w-4xl mx-auto mb-12">
              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 shadow-lg border border-gray-300">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Información Adicional
                </h3>
                <div className="prose prose-gray max-w-none text-center">
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {vehicleData.Observaciones}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* MercadoLibre Section */}
          {/* {vehicleData && vehicleData.urlMercadoLibre && (
            <div className="max-w-4xl mx-auto mb-12">
              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 shadow-lg border border-gray-300">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Ver en MercadoLibre
                </h3>
                <div className="text-center">
                  <a
                    href={vehicleData.urlMercadoLibre}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-4 bg-gradient-to-r from-gray-700 to-gray-900 text-white px-8 py-4 rounded-2xl hover:from-gray-800 hover:to-gray-950 transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl border border-gray-600"
                  >
                    <MercadoLibreIcon className="w-12 h-12" />
                    <span className="text-lg font-bold">Ver Publicación Completa</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          )} */}

          {/* Contact CTA */}
          <div className="max-w-2xl mx-auto mb-8 text-center">
            <div className="bg-gradient-to-r from-gray-200 to-gray-300 rounded-2xl p-8 shadow-xl border border-gray-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                ¿Interesado en este vehículo?
              </h3>
              <p className="text-gray-700 mb-6">
                Contactanos para más información, financiación o para coordinar una visita.
              </p>
              <a
                href="https://walink.co/f717a6"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-gradient-to-r from-gray-700 to-gray-900 text-white px-6 py-3 rounded-xl hover:from-gray-800 hover:to-gray-950 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                </svg>
                <span>Consultar por WhatsApp</span>
              </a>
            </div>
          </div>

        </div>

        <div className="bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300">
          <WhatsApp />
          <NavigationButtons />
        </div>
      </div>

      <style jsx global>{`
        body {
          background: linear-gradient(to bottom right, #f3f4f6, #e5e7eb, #d1d5db) !important;
        }
      `}</style>
    </>
  );
};

export default VehiculoDetalle;